import { HttpContextToken } from '@angular/common/http';

export const IS_SEARCH = new HttpContextToken<boolean>(() => false);

export const IS_LOAD = new HttpContextToken<boolean>(() => false);

export const IS_ACTION = new HttpContextToken<boolean>(() => false);

export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
